import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";

class Stage13Invalid extends React.Component {
    constructor(props){
        super(props);
    }



    render() {

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        const headerAndWelcomeText = <div>
            <Header
                textResource={"invalid_title"}
                name={`${this.props.apiData.firstName} ${this.props.apiData.lastName} `}
            />
            <SpacerRow/>
            <TextBody
                textResource={"invalid_body_1"}
            />
            <TextBody
                textResource={"invalid_body_2"}
            />
            <TextBody
                textResource={"invalid_body_3"}
            />
        </div>;

        const statusBar = <StatusOverview
            showDescription={true}
        />;

        return <Container>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <Row className={"padding-top-24-validation"}></Row>
                <Row>
                    <Col xs={12}>
                        <Header textResource={"invalid_title"} />
                    </Col>
                </Row>
                <Row className={"padding-top-24-validation"}></Row>
                <Row className={"padding-top-24-validation"}></Row>
                <Row>
                    <Col xs={12}>
                        <TextBody
                            textResource={"invalid_body_1"}
                        />
                    </Col>
                </Row>
                <Row className={"padding-top-24-validation"}></Row>
                <Row>
                    <Col xs={12}>
                        <TextBody
                            textResource={"invalid_body_3"}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <TextBody
                            textResource={"invalid_body_4"}
                        />
                    </Col>
                </Row>

            </MobileView>
            <BrowserView>
                <Container>
                    <Row>
                    {footerLnk}
                    </Row>
                <Row>
                    <Col xs={2} style={{marginTop:"15px", height:"68px"}}>

                    </Col>
                </Row>
                <Row>
                    <Col xs={{size: 9, offset: 3}}>
                        <Row className={"padding-top-24-validation"}></Row>
                        <Row>
                            <Col xs={12}>
                                <Header textResource={"invalid_title"} />
                            </Col>
                        </Row>
                        <Row className={"padding-top-24-validation"}></Row>
                        <Row className={"padding-top-24-validation"}></Row>
                        <Row>
                            <Col xs={12}>
                                <TextBody
                                    textResource={"invalid_body_1"}
                                />
                            </Col>
                        </Row>
                        <Row className={"padding-top-24-validation"}></Row>
                        <Row>
                            <Col xs={12}>
                                <TextBody
                                    textResource={"invalid_body_3"}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <TextBody
                                    textResource={"invalid_body_4"}
                                />
                            </Col>
                        </Row>
                        <Row className={"padding-top-24-validation"}></Row>
                    </Col>
                </Row>
                </Container>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage13Invalid);